export default {
  // Навигация и меню
  nav: {
    sessions: 'Сессии',
    admin: 'Админ-панель',
    prompts: 'Промпты',
    logout: 'Выход',
    settings: 'Настройки',
    changelog: 'Changelog',
    downloadPlugin: 'Скачать плагин',
    tipsAndTricks: 'Советы и хитрости',
    privacyPolicy: 'Политика конфиденциальности'
  },

  // Авторизация
  auth: {
    title: 'AI Stenograph',
    subtitle: 'Расшифровка и суммаризация встреч',
    email: 'Email',
    password: 'Пароль',
    login: 'Войти',
    loginWithGoogle: 'Войти через Google',
    loading: 'Загрузка...',
    loggingIn: 'Вход...',
    authError: 'Ошибка авторизации',
    invalidCredentials: 'Неверный email или пароль',
    serverError: 'Ошибка сервера. Попробуйте позже.',
    welcome: 'Добро пожаловать',
    checkingAuth: 'Проверка авторизации...',
    checkingPermissions: 'Проверка прав доступа...',
    loginSuccess: 'Авторизация успешна! Загрузка панели...',
    accessDenied: 'У вас нет доступа к системе',
    permissionCheckError: 'Ошибка проверки прав доступа',
    connectionError: 'Ошибка подключения к серверу',
    loggedOut: 'Вы вышли из системы',
    checkingSavedAuth: 'Проверка сохраненной авторизации...',
    reAuthRequired: 'Необходима повторная авторизация'
  },

  // Пользователь
  user: {
    roles: {
      owner: 'Владелец',
      administrator: 'Администратор',
      user: 'Пользователь'
    },
    tokenValid: 'Токен действителен:',
    tokenExpired: 'Токен истек',
    defaultName: 'Пользователь'
  },

  // Сессии
  sessions: {
    title: 'Мои записи',
    search: 'Поиск по названию или транскрипции...',
    noSessions: 'У вас пока нет записей',
    noSessionsDesc: 'Чтобы начать использование сервиса, необходимо установить плагин для Chrome и авторизоваться. После этого вы сможете записывать и транскрибировать аудио из вкладок браузера и микрофона.',
    installPlugin: 'Установить плагин',
    pluginLoginHint: 'После установки не забудьте авторизоваться в плагине для синхронизации записей',
    features: {
      recording: 'Запись из вкладок и микрофона',
      transcription: 'Транскрипция с помощью AI',
      summary: 'Автоматическая генерация саммари'
    },
    loading: 'Загрузка записей...',
    status: {
      processing: 'Обработка',
      completed: 'Завершена',
      failed: 'Ошибка',
      finalizing: 'Финализация',
      pending: 'Ожидание',
      receiving: 'Получение',
      paused: 'Приостановлена',
      recording: 'Запись',
      reprocessing: 'Переобработка'
    },
    duration: 'Длительность',
    view: 'Открыть',
    viewText: 'Текст',
    viewInterim: 'Просмотреть промежуточный текст',
    viewTranscript: 'Просмотреть текст транскрипции',
    delete: 'Удалить',
    deleteSession: 'Удалить сессию',
    deleteConfirm: 'Удалить запись?',
    deleteWarning: 'Это действие нельзя отменить',
    deleteEntry: 'Удаление записи',
    cancel: 'Отмена',
    summary: 'Саммари',
    createSummary: 'Создать',
    viewSummary: 'Просмотреть саммари',
    transcription: 'Транскрипция',
    transcriptionText: 'Текст транскрипции',
    noTranscription: 'Транскрипция недоступна',
    noSummary: 'Саммари еще не создано',
    noSummaryDesc: 'Нажмите кнопку "Создать" выше, чтобы сгенерировать краткое содержание транскрипции.',
    viewSummary: 'Просмотреть саммари',
    createSummary: 'Создать саммари',
    recreateSummary: 'Пересоздать саммари',
    recreate: 'Пересоздать',
    promptLabel: 'Промпт:',
    fullIdTooltip: 'Полный ID: {id} (нажмите чтобы скопировать)',
    dateUnknown: 'Дата неизвестна',
    copyTranscript: 'Скопировать транскрипцию',
    copySummary: 'Скопировать саммари',
    copied: 'Скопировано!',
    download: 'Скачать',
    downloaded: 'Скачано',
    regenerateSummary: 'Пересоздать саммари',
    regenerating: 'Пересоздание...',
    generatingSummary: 'Генерация саммари...',
    close: 'Закрыть',
    edit: 'Редактировать',
    save: 'Сохранить',
    editTitle: 'Редактировать название',
    saveTitle: 'Сохранить название',
    titleSaved: 'Название сохранено',
    titleError: 'Ошибка сохранения названия',
    anonymousUser: 'Анонимный пользователь',
    fullId: 'Полный ID',
    clickToCopy: 'нажмите чтобы скопировать',
    ttlInfinite: 'TTL бесконечный',
    makeTTLInfinite: 'Нажмите, чтобы сделать TTL бесконечным',
    ttlExpired: 'Истекла',
    systemStats: 'Статистика системы',
    totalSessions: 'Всего сессий',
    completedSessions: 'Завершено',
    failedSessions: 'Ошибки',
    processingTime: 'Среднее время обработки',
    createNewSummary: 'Создать новое саммари',
    selectSavedPrompt: 'Выберите из сохраненных промптов:',
    orEnterCustom: 'или введите свой промпт',
    enterCustomPrompt: 'Введите промпт для нового саммари...',
    enterPromptPlaceholder: 'Введите промпт для нового саммари...',
    generate: 'Генерировать',
    screenshots: 'Ножницы',
    autoScreenshots: 'Автоматически сохранять снимки экрана.',
    scissors: 'Ножницы',
    waitingForTranscription: '[Ожидание первой транскрипции...]',
    transcriptionWillAppear: 'Текст появится через ~60 секунд после начала записи.',
    autoUpdating: 'автообновляется',
    streamingMode: 'Потоковая обработка (real-time)',
    qualityMode: 'Качественная обработка (после записи)',
    // Аудио
    hasAudio: 'Аудио сохранено',
    audioNotSaved: 'Аудио не сохранено',
    audioSkippedStorageLimit: 'Недостаточно места',
    audioAutoDeleted: 'Аудио автоудалено',
    audioLocked: 'Аудио защищено от удаления',
    audioUnlocked: 'Аудио не защищено',
    audio: 'Аудио',
    lockAudio: 'Защитить от автоудаления',
    unlockAudio: 'Снять защиту',
    playAudio: 'Воспроизвести аудио',
    loadingAudio: 'Загрузка аудио...',
    downloadAudio: 'Скачать аудио',
    deleteAudio: 'Удалить аудио',
    deleteAudioConfirm: 'Удалить аудиозапись? Транскрипция сохранится.',
    reprocess: 'Переобработать',
    reprocessAgain: 'Обработать заново',
    reprocessConfirm: 'Переобработать запись в режиме качества? Текущая транскрипция будет заменена.',
    reprocessing: 'Переобработка...',
    reprocessStarted: 'Переобработка запущена',
    reprocessCompleted: 'Переобработка завершена',
    audioDeleted: 'Аудиозапись удалена',
    audioDownloadError: 'Ошибка скачивания аудио'
  },

  // Админ-панель
  admin: {
    title: 'Пользователи',
    subtitle: 'Управление доступом пользователей',
    search: 'Поиск по email...',
    addUser: 'Добавить пользователя',
    noUsers: 'Пользователи не найдены',
    loading: 'Загрузка пользователей...',
    email: 'Email',
    role: 'Роль',
    created: 'Создан',
    actions: 'Действия',
    edit: 'Редактировать',
    delete: 'Удалить',
    roles: {
      owner: 'owner',
      administrator: 'administrator',
      user: 'user'
    },
    addUserTitle: 'Добавить нового пользователя',
    editUserTitle: 'Редактировать пользователя',
    password: 'Пароль',
    betaTester: 'Бета-тестер',
    betaTesterAdded: 'Пользователь добавлен в бета-тестеры',
    betaTesterRemoved: 'Пользователь убран из бета-тестеров',
    betaTesterError: 'Ошибка изменения статуса бета-тестера',
    qualitySettings: 'Настройки обработки',
    qualityMode: 'Качественная обработка',
    storageLimit: 'Лимит хранилища',
    deleteUser: 'Удалить пользователя',
    passwordHint: 'Оставьте пустым для сохранения текущего',
    save: 'Сохранить',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    deleteConfirm: 'Удалить пользователя?',
    deleteWarning: 'Это действие нельзя отменить',
    userAdded: 'Пользователь добавлен',
    userUpdated: 'Пользователь обновлен',
    userDeleted: 'Пользователь удален',
    error: 'Ошибка операции',
    loadError: 'Ошибка загрузки списка пользователей',
    addError: 'Ошибка добавления пользователя',
    deleteUserTitle: 'Удаление пользователя',
    roleChangeError: 'Ошибка при изменении роли',
    changesSaved: 'Изменения успешно сохранены',
    changeError: 'Ошибка при изменении'
  },

  // Промпты
  prompts: {
    title: 'Мои промпты',
    subtitle: 'Управление шаблонами промптов для саммари',
    create: 'Создать промпт',
    created: 'Создан:',
    updated: 'Обновлен:',
    createdAt: 'Создан',
    updatedAt: 'Обновлен',
    noPrompts: 'У вас пока нет сохраненных промптов',
    createFirst: 'Создать первый промпт',
    loading: 'Загрузка промптов...',
    newPrompt: 'Новый промпт',
    editPrompt: 'Редактировать промпт',
    name: 'Название',
    namePlaceholder: 'Например: Краткое саммари',
    content: 'Текст промпта',
    contentPlaceholder: 'Введите текст промпта...',
    save: 'Сохранить',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    edit: 'Редактировать',
    delete: 'Удалить',
    confirmDeleteTitle: 'Подтвердите действие',
    confirmDeleteMessage: 'Вы уверены, что хотите удалить этот промпт?',
    confirmDeleteWarning: 'Это действие нельзя отменить.',
    deleteConfirm: 'Удалить',
    deleteCancel: 'Отмена',
    deleting: 'Удаление...',
    created: 'Создан',
    updated: 'Обновлен',
    promptCreated: 'Промпт успешно создан',
    promptUpdated: 'Промпт успешно обновлен',
    promptDeleted: 'Промпт успешно удален',
    error: 'Ошибка операции',
    loadError: 'Ошибка загрузки промптов',
    saveError: 'Ошибка сохранения промпта',
    deleteError: 'Ошибка удаления промпта'
  },

  // Changelog
  changelog: {
    title: 'Changelog',
    add: 'Добавить',
    addEntry: 'Добавить запись',
    editEntry: 'Редактировать запись',
    component: 'Компонент',
    version: 'Версия',
    date: 'Дата',
    dateRelease: 'Дата релиза',
    dateHint: 'Можно указать дату прошлого релиза',
    changes: 'Изменения (по одному на строку)',
    changesHint: 'Каждая строка = одно изменение. Можно использовать +, -, *, ✓ в начале строки',
    changesPlaceholder: '- Добавлена новая функция\n- Исправлен баг с...\n+ Улучшена производительность',
    save: 'Сохранить',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    confirmDeleteEntry: 'Удалить запись {component} v{version}?',
    edit: 'Редактировать',
    delete: 'Удалить',
    noEntries: 'Нет записей',
    plugin: 'Plugin',
    backend: 'Backend',
    frontend: 'Frontend',
    loading: 'Загрузка...',
    saved: 'Запись сохранена',
    deleted: 'Запись удалена',
    error: 'Ошибка операции',
    loadError: 'Не удалось загрузить changelog',
    versionRequired: 'Укажите версию',
    changesRequired: 'Добавьте хотя бы одно изменение',
    saveError: 'Ошибка при сохранении changelog',
    deleteError: 'Ошибка при удалении записи'
  },

  // Общие элементы
  common: {
    close: 'Закрыть',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    title: 'Название',
    create: 'Создать',
    loading: 'Загрузка...',
    error: 'Ошибка',
    success: 'Успешно',
    confirm: 'Подтвердить',
    search: 'Поиск',
    yes: 'Да',
    no: 'Нет',
    text: 'Текст',
    summary: 'Саммари',
    download: 'Скачать',
    downloadFile: 'Скачать файл',
    view: 'Просмотр',
    add: 'Добавить',
    generate: 'Сгенерировать',
    clickToCopy: 'Нажмите чтобы скопировать',
    copied: 'Скопировано в буфер обмена!',
    copyError: 'Ошибка копирования',
    languageSwitchIcon: '🇬🇧',
    languageSwitchText: 'English',
    connectionError: 'Ошибка подключения к серверу'
  },

  // Настройки
  settings: {
    title: 'Настройки',
    transcription: 'Настройка транскрипции',
    transcriptionConfig: 'Настройка транскрипции',
    language: 'Язык интерфейса',
    theme: 'Тема оформления',
    dark: 'Темная тема',
    light: 'Светлая тема',
    auto: 'Авто',
    temperature: 'Temperature (Точность транскрипции)',
    temperatureDesc: 'Temperature = 0.0 дают детерминированные результаты и минимум галлюцинаций. Повышение значения увеличивает вариативность, но может снизить точность.',
    maxAccuracy: 'Максимальная точность (рекомендуется)',
    balanced: 'Сбалансированный',
    maxVariability: 'Максимальная вариативность',
    resetToDefaults: 'Сбросить к значениям по умолчанию',
    settingsSaved: 'Настройки сохранены',
    settingsSaveError: '❌ Ошибка сохранения настроек',
    // Качественная обработка
    qualityMode: 'Качественная обработка',
    qualityModeDesc: 'Использовать медленный, но более точный метод с полным контекстом вместо быстрого стриминга',
    qualityModeNote: 'Рекомендуется для важных встреч и длинных записей. Обработка займёт больше времени, но качество будет выше.',
    enabled: 'Включено',
    disabled: 'Выключено',
    cannotChangeWhileRecording: 'Нельзя изменить настройку во время активной записи',
    // Сохранение аудио
    saveAudio: 'Сохранять аудиозапись',
    saveAudioDesc: 'Сохранять исходную аудиозапись после транскрибации. Позволяет переобработать запись в режиме качества или скачать.',
    saveAudioNote: 'Аудиофайлы занимают дополнительное место на сервере. Рекомендуется удалять ненужные записи.',
    // Циклическая запись
    autoDeleteOldest: 'Циклическая запись',
    autoDeleteOldestDesc: 'Автоматически удалять старые аудиозаписи при превышении лимита хранилища для освобождения места под новые.',
    autoDeleteOldestNote: 'Заблокированные записи (🔒) не будут удаляться автоматически.',
    // Хранилище
    storageTitle: 'Использование хранилища',
    storageUsed: 'Использовано',
    storageLimit: 'Лимит',
    storageAudio: 'Аудиозаписи',
    storageTranscriptions: 'Транскрипции',
    storageNearLimit: 'Заканчивается место',
    storageOverLimit: 'Лимит превышен',
    storageLimitWarning: 'Новые аудиозаписи не будут сохраняться при превышении лимита.',
  },

  // Системный статус
  system: {
    status: 'Статус системы',
    healthy: 'Работает',
    degraded: 'Деградация',
    unhealthy: 'Не работает',
    unknown: 'Неизвестно',
    allSystemsHealthy: 'Все системы работают нормально',
    someSystemsWarning: 'Некоторые системы работают с предупреждениями',
    systemsHaveErrors: 'Обнаружены проблемы в работе систем',
    statusUnknown: 'Статус системы неизвестен',
    services: {
      redis: 'Redis',
      whisper: 'Whisper API',
      openai: 'OpenAI',
      storage: 'Хранилище'
    }
  },

  // Статистика
  stats: {
    title: 'Статистика системы',
    sessions: 'Сессии',
    total: 'Всего',
    completed: 'Завершено',
    active: 'Активных',
    failed: 'Ошибки',
    processing: 'Обработка',
    averageTime: 'Среднее время',
    totalTime: 'Общее время',
    users: 'Пользователей',
    totalUsers: 'Всего пользователей',
    activeUsers: 'Активных пользователей',
    totalAnonymousCreated: 'Всего создано анонимных сессий',
    currentAnonymousSessions: 'Текущих анонимных сессий в системе',
    disk: 'Диск',
    free: 'своб.',
    pluginInstalls: 'Установок плагина',
    pluginInstallsExpanded: 'Установки плагина',
    anonymousSessions: 'Анонимных сессий',
    allSystemSessions: 'Все сессии системы',
    userFilter: 'Пользователь:',
    allUsers: 'Все пользователи',
    sessionsLabel: 'СЕССИЙ:',
    completedLabel: 'ЗАВЕРШЕНО:',
    errorsLabel: 'ОШИБКИ:',
    durationLabel: 'ДЛИТЕЛЬНОСТЬ:',
    activityPeriod: 'Период активности:',
    last24h: 'Последние 24 часа',
    last7d: 'Последние 7 дней',
    last30d: 'Последние 30 дней',
    allTime: 'Всё время',
    version: 'Версия',
    id: 'ID',
    email: 'Email',
    lastIp: 'Последний IP',
    country: 'Страна',
    beta: 'Бета',
    lastActivity: 'Последняя активность',
    hoursAgo: 'ч назад',
    minutesAgo: 'мин назад',
    daysAgo: 'д назад',
    hour: 'ч',
    minute: 'м',
    day: 'д',
    of: 'из',
    noUserSessions: 'У этого пользователя нет сессий',
    noSessionsFound: 'Сессии не найдены',
    loadMore: 'Загрузить ещё',
    loading: 'Загрузка...',
  },

  // Ошибки плагина
  pluginErrors: {
    title: 'Ошибки плагина',
    allVersions: 'Все версии',
    allTypes: 'Все типы',
    allTrust: 'Все уровни',
    authenticated: 'Авторизованный',
    anonymous: 'Анонимный',
    clearAll: 'Очистить все',
    confirmClear: 'Удалить все ошибки плагина? Это действие необратимо.',
    time: 'Время',
    version: 'Версия',
    type: 'Тип',
    message: 'Сообщение',
    trust: 'Доверие',
    user: 'Пользователь',
    count: 'Кол-во',
    noErrors: 'Ошибок не найдено',
  },

  // Модальные окна
  modal: {
    close: 'Закрыть',
    confirm: 'Подтвердить',
    installPlugin: {
      title: 'Установить AI Stenograph',
      chromeWebStore: 'Установить из Chrome Web Store',
      chromeWebStoreDesc: 'Самый простой способ установки - через официальный магазин расширений Chrome. Нажмите кнопку ниже, чтобы перейти на страницу плагина.',
      openChromeStore: 'Открыть в Chrome Web Store'
    },
    tips: {
      title: 'Советы и хитрости',
      authTitle: 'Авторизация',
      authDesc: 'Войдите с тем же Google-аккаунтом, что и на сайте, чтобы сохранять транскрипции на сервере.',
      authAnonymous: 'Можно использовать анонимный режим — такие записи сохраняются только локально.',
      webViewTitle: 'Просмотр через веб-интерфейс',
      webViewDesc: 'Нажмите на значок облака в списке записей, чтобы открыть транскрипцию в веб-интерфейсе.',
      editTitle: 'Редактирование записей',
      editDesc: 'Вы можете переименовывать записи или удалять их — как локально, так и с сервера.',
      hotkeysTitle: 'Горячие клавиши',
      hotkeyRecord: '— начать или остановить запись',
      hotkeyActivation: '— включить или отключить плагин',
      hotkeyMic: '— включить или выключить микрофон',
      permissionsTitle: 'Первый запуск',
      permissionsDesc: 'При первом использовании предоставьте доступ к микрофону и разрешение на запись вкладок.',
      autoStopTitle: 'Автоматическая остановка',
      autoStopDesc: 'Настройте автоматическую остановку при отсутствии звука. По умолчанию — через 1 минуту.',
      googleMeetTitle: 'Google Meet',
      googleMeetDesc: 'Плагин может автоматически начинать запись при входе в конференцию.',
      micDetectionTitle: 'Определение состояния микрофона',
      micDetectionDesc: 'Плагин отслеживает статус микрофона в Google Meet: если он выключен в самой встрече — запись микрофона не ведётся.',
      advancedSettingsTitle: 'Дополнительные настройки',
      advancedSettingsDesc: 'Нажмите на номер версии внизу настроек, чтобы открыть расширенные параметры.',
      audioSourceTitle: 'Источник звука',
      audioSourceDesc: 'Выберите, что записывать: микрофон или звук вкладки.',
      languageTitle: 'Язык митинга',
      languageDesc: 'Укажите язык встречи заранее или во время записи для улучшения распознавания. Неверно выбранный язык приведёт к переводу записи.'    },
    privacy: {
      title: 'Политика конфиденциальности',
      loadError: 'Не удалось загрузить политику конфиденциальности'
    }
  },
}

